import { render, staticRenderFns } from "./ProductIcon.vue?vue&type=template&id=fc27d90e&scoped=true"
import script from "./ProductIcon.vue?vue&type=script&lang=js"
export * from "./ProductIcon.vue?vue&type=script&lang=js"
import style0 from "./ProductIcon.vue?vue&type=style&index=0&id=fc27d90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc27d90e",
  null
  
)

export default component.exports